import { Expense } from "@finway-group/shared/lib/models"
import { getApprovalProcessScopeFromExpenseStatus } from "@finway-group/shared/lib/utils/approvalProcess.utils"
import { MAX_INPUT_LENGTH } from "@finway-group/shared/lib/utils/validators"
import { Form, Input, Modal } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { useHistory, useLocation } from "react-router-dom"
import { ExpenseRules } from "~Components/forms/rules"
import { ExpenseSwitchingLocationState } from "~Components/PageCustomHeader"
import { rejectExpenseRequest } from "~Shared/hooks/expense.hooks"
import { UserService } from "~Shared/services"
import { useStateIfMounted } from "~Shared/utils/hooks/useStateIfMounted"

interface RejectModalProps {
    isVisible: boolean
    title: string
    message: string
    okText: string
    cancelText: string
    request: Expense
    nextExpense?: string
    onCancel: () => void
}
export const RejectModal = ({ request, isVisible, title, message, okText, cancelText, nextExpense, onCancel }: RejectModalProps) => {
    const history = useHistory()
    const location = useLocation<ExpenseSwitchingLocationState>()
    const [form] = Form.useForm()
    const { t } = useTranslation()
    const loggedInProfile = UserService.getLoggedInEmployeeProfile()
    const [isLoading, setIsLoading] = useStateIfMounted(false)
    const { reasonToReject: reasonToRejectRules } = ExpenseRules({})

    const onFormSubmit = (values: { [key: string]: string }) => {
        setIsLoading(true)
        const scope = getApprovalProcessScopeFromExpenseStatus(request.status)
        rejectExpenseRequest({ expense: request, rejectionNote: values.reasonToReject, history, scope })
            .then(() => {
                handleHide()
                if (loggedInProfile.settings.enableGoToNextExpense && nextExpense) {
                    history.push({ pathname: nextExpense, state: { expenseSwitchingSteps: (location.state?.expenseSwitchingSteps ?? 0) + 1 } })
                }
            })
            .catch(() => {
                setIsLoading(false)
            })
    }

    const handleHide = () => {
        setIsLoading(false)
        form.resetFields()
        onCancel()
    }

    return (
        <Modal
            title={title}
            open={isVisible}
            maskClosable={false}
            onOk={form.submit}
            onCancel={handleHide}
            okText={okText}
            cancelText={cancelText}
            keyboard
            destroyOnClose
            confirmLoading={isLoading}
        >
            <Form form={form} layout="vertical" onFinish={onFormSubmit}>
                <Form.Item name="reasonToReject" key="reasonToReject" label={message} required rules={reasonToRejectRules}>
                    <Input placeholder={t("placeholder:request.reject")} maxLength={MAX_INPUT_LENGTH} />
                </Form.Item>
            </Form>
        </Modal>
    )
}
